<template>
    <div class="mt-4">
        <div
            v-if="$slots?.default"
            class="text-sm font-semibold text-gray-800 mb-2"
        >
            <slot />

            <div
                v-if="$slots?.subtitle"
                class="text-sm font-normal won-color-subtitle-gray mt-0.5"
            >
                <slot name="subtitle" />
            </div>
        </div>

        <textarea
            ref="textarea"
            :placeholder="placeholder"
            :rows="rows"
            :class="[
                'won-textarea',
                inputStyle,
                classList,
                {
                    'border-red-400': errors,
                    'border-gray-300': !errors,
                },
            ]"
            @input="(e) => handleChange(e.target.value)"
            @blur="$emit('input:blur')"
        />

        <div class="mt-2">
            <p
                v-for="error in errors"
                class="flex items-center space-x-2"
                :key="error"
            >
                <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M7.00016 0.333008C3.32016 0.333008 0.333496 3.31967 0.333496 6.99967C0.333496 10.6797 3.32016 13.6663 7.00016 13.6663C10.6802 13.6663 13.6668 10.6797 13.6668 6.99967C13.6668 3.31967 10.6802 0.333008 7.00016 0.333008ZM7.66683 10.333H6.3335V8.99967H7.66683V10.333ZM7.66683 7.66634H6.3335V3.66634H7.66683V7.66634Z"
                        fill="#FF5F5F"
                    />
                </svg>
                <span class="text-red-500 text-sm">{{ error }}</span>
            </p>
        </div>
    </div>
</template>

<script>
import { onMounted, ref, watch } from "vue";

import { inputStyle } from "../../utils/styles";

export default {
    props: {
        placeholder: String,
        modelValue: String,
        classList: {
            type: String,
            default: "",
        },
        rows: {
            type: Number,
            default: 2
        },
        errors: {
            type: Array,
            default: null,
        },
        storageKey: {
            type: String,
            default: undefined,
        },
        name: {
            type: String,
            default: 'textarea',
        }
    },
    setup(props, { emit }) {
        const textarea = ref(null); // Create ref for textarea

        // Watch for changes in modelValue and update textarea value
        watch(() => props.modelValue, (newVal) => {
            if (textarea.value) {
                textarea.value.value = newVal || '';  // Set the textarea value
            }
        });

        onMounted(() => {
            if (props.storageKey) {
                const fullKey = `WONSULTING-${props.storageKey}`;
                const value = localStorage.getItem(fullKey);

                if (value) {
                    emit("update:modelValue", value);
                }
            }
        });

        const handleChange = (value) => {
            emit("update:modelValue", value);

            if (props.storageKey) {
                const fullKey = `WONSULTING-${props.storageKey}`;
                localStorage.setItem(fullKey, value);
            }
        };

        return {
            inputStyle,
            textarea, // Expose the textarea ref
            handleChange,
        };
    },
};
</script>

<style>
.won-textarea {
    resize: none;
    overflow-y: auto !important;
}
</style>
